// extracted by mini-css-extract-plugin
export default {"container":"CardSolucoes_container__x4IyY"};